



















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Getter } from 'vuex-class';
import { PolicyRisks } from '@/common/Policy';

import TextField from '@/components/Form/TextField.vue';
import SwitchField from '@/components/Form/SwitchField.vue';
import Checkbox from '@/components/Form/Checkbox.vue';
import Loading from '@/components/Global/Loading.vue';
import Alert from '@/components/Global/Alert.vue';
import UmiaUserRoles from '@/components/Staff/UserManagement/Roles/UmiaRoles.vue';
import InsureCareTeamsRoles from '@/components/Staff/UserManagement/Roles/InsureCareTeamsRoles.vue';
import Welcome from '@/components/Global/Welcome.vue';

// Services
import Staff from '@/services/Staff';
import Brand from '@/services/Brand';
import * as Sentry from '@sentry/browser';

// Validations
import { required, email } from 'vuelidate/lib/validators';

@Component({
	name: 'ManageUser',
	components: {
		Loading,
		Alert,
		UmiaUserRoles,
		InsureCareTeamsRoles,
		TextField,
		SwitchField,
		Welcome,
		Checkbox,
	},
	validations: {
		user: {
			email: {
				required,
				email,
			},
			phone_number: {
				required,
			},
		},
	},
})
export default class ManageUser extends Vue {
	@Getter('policies', { namespace: 'Policy' }) private policies;
	@State('selectedInvite', { namespace: 'OrgAdmin' }) private invite!: any;
	@State('selectedMember', { namespace: 'OrgAdmin' }) private member!: any;
	private success: boolean = false;
	private error: boolean = false;
	private errorSave: boolean = false;
	private siteAccess: any = [];
	private loading: boolean = true;
	private user: any = {};
//	private brand: string = '';
	private roleComponent: any = undefined;
	private selectAllToggle: boolean = false;

	@Watch('selectAllToggle', { deep: true })
	private watchUser(newValue, oldValue) {
		this.policies.map(p => {
			this.user.policies[p.policy_number] = this.selectAllToggle;
		});
	}

	/**
	 * Save the user data to the api
	 */
	private async saveUserData() {
		try {
			if (this.$route.name === 'org_manageemail') {
				delete this.user.invitee_permissions.permissions;
				const updateData = await this.$store.dispatch('OrgAdmin/saveInvite', this.user);
			} else {
				const updateData = await this.$store.dispatch('OrgAdmin/saveUser', this.user);
			}
			this.success = true;
			window.scrollTo(0, 0);
		} catch (e) {
			console.log(e);
			Sentry.captureException(e);
			this.errorSave = true;
			this.success = false;
			window.scrollTo(0, 0);
		}
	}

	private async loadUser() {
		try {
			if (this.$route.name === 'org_manageemail') {
				await this.$store.dispatch('OrgAdmin/getInvite', this.$route.params.email);
			} else {
				await this.$store.dispatch('OrgAdmin/getUser', this.$route.params.subId);
			}

			switch (Brand.getBrand()) {
				case 'mmic':
					this.roleComponent = () =>
						import(
							/* webpackChunkName: "Roles" */ '@/components/Staff/UserManagement/Roles/MmicRoles.vue'
						);
					break;

				case 'umia':
					this.roleComponent = () =>
						import(
							/* webpackChunkName: "Roles" */ '@/components/Staff/UserManagement/Roles/UmiaRoles.vue'
						);
					break;

                                case 'rrg':
                                        this.roleComponent = () =>
                                                import(
                                                        /* webpackChunkName: "Roles" */ '@/components/Staff/UserManagement/Roles/RrgRoles.vue'
                                                );
                                        break;

			}

			this.user = this.invite || this.member;
		} catch (e) {
//			console.log(`loadUser()->${e}`);
			Sentry.captureException(e);
			this.error = true;
			this.siteAccess = [];
		} finally {
			this.loading = false;
		}
	}

	private async created() {
		await this.loadUser();
	}
}
